// extracted by mini-css-extract-plugin
export default {"audioTabContentContainer":"audioTabContentContainer-tZejBB0G","title":"title-jp5gFsBX"};